export const BOUNDARY_POLYGON_UPDATE_REQUEST = 'BOUNDARY_POLYGON_UPDATE_REQUEST';
export const BOUNDARY_POLYGON_UPDATE_STARTED = 'BOUNDARY_POLYGON_UPDATE_STARTED';
export const BOUNDARY_POLYGON_UPDATE_FINISHED = 'BOUNDARY_POLYGON_UPDATE_FINISHED';
export const BOUNDARY_POLYGON_UPDATE_ERROR = 'BOUNDARY_POLYGON_UPDATE_ERROR';
